import { render, staticRenderFns } from "./FeedNew.vue?vue&type=template&id=0a1e56ce&scoped=true&"
import script from "./FeedNew.vue?vue&type=script&lang=js&"
export * from "./FeedNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e56ce",
  null
  
)

export default component.exports